import { render, staticRenderFns } from "./QuestionRichBody.vue?vue&type=template&id=40a8df14&scoped=true"
import script from "./QuestionRichBody.vue?vue&type=script&lang=js"
export * from "./QuestionRichBody.vue?vue&type=script&lang=js"
import style0 from "./QuestionRichBody.vue?vue&type=style&index=0&id=40a8df14&prod&scoped=true&lang=css"
import style1 from "./QuestionRichBody.vue?vue&type=style&index=1&id=40a8df14&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40a8df14",
  null
  
)

export default component.exports